<template>
  <div class="product-detail">
    <div v-if="product" class="product-card">
      <img :src="product.image" alt="Product Image" class="product-image"/>
      <h2 class="product-title">{{ product.name }}</h2>
      <p class="product-description">{{ product.description }}</p>
      <div class="product-price">单价: {{ product.price }}</div>
      
      <div class="form-group">
        <label style="  color: red;" for="email">联系邮箱（重要，查询唯一凭证）:</label>
        <input type="email" id="email" v-model="email" placeholder="请输入您的邮箱" required/>
        <div v-if="emailError" class="error-message">{{ emailError }}</div>
      </div>

      <!-- <div class="form-group">
        <label style="  color: red;" for="phone">联系手机（重要，查询唯二凭证）:</label>
        <input type="phone" id="phone" v-model="email" placeholder="请输入您的手机" required/>
        <div v-if="emailError" class="error-message">{{ emailError }}</div>
      </div> -->


      <div class="form-group">
        <label for="quantity">购买数量:</label>
        <input type="number" id="quantity" v-model.number="quantity" min="1" @input="calculateTotalPrice" />
      </div>

      <div class="total-price">总价: {{ totalPrice }}</div>

      <button @click="placeOrder" class="order-button">下单</button>
    </div>
  </div>
  <div v-if="isCdKeyAvailable">
      <div class="modal">
        <div class="modal-content">
          <input type="text" ref="orderUrlInput" :value="cdKey" >
          <p style="color: red;">不要关闭刷新窗口，请复制cdkey到游戏中使用完再关闭</p>
          <button @click="copyToClipboard">一键复制</button>
          
        </div>
      </div>
    </div>
    <div v-else-if="isValidResponse"> 
   
      <div v-if="isMobile">
        <div class="modal">
          <div class="modal-content">
            <input style="width: 300px;" type="text" ref="orderUrlInput" :value="orderUrl" >
            <p style="color: red;">请复制链接到微信聊天框中打开支付</p>
            <button style="margin-right: 10px;" @click="copyToClipboard">一键复制</button>
         
            <button @click="closeModal">关闭</button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="modal">
          <div class="modal-content">
            <p>请使用微信扫码支付：</p>
            <img :src="qrCodeUrl" alt="QR Code" />
            
            <button @click="closeModal">关闭</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      
      <p>无效数据</p>
    </div>
 
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      product: null,
      email: '',
      quantity: 1,
      totalPrice: 0,
      orderUrl: '',
      qrCodeUrl: '',
      newProductId:'',
      isValidResponse: false,
      isCdKeyAvailable: false,
      isMobile: false,
      intervalId: null,
      orderParams: {
        
      }
    };
  },
  created() {
    const productId = this.$route.params.id; // 从路径中获取ID
    this.fetchProduct(productId)
  },
  methods: {
    fetchProduct(productId) {
      // 假设产品列表是从服务器获取或者在本地存储的
      const productList = [
        
        { id: 1, name: '赞助宝箱', price: 100, image: require('../assets/logo.jpg'), description: '可随机获得银子、神兜兜、特殊兽决、无级别宝珠等奖励。' },
        { id: 2, name: '赞助宝箱', price: 200, image: require('../assets/logo.jpg'), description: '可随机获得银子、神兜兜、特殊兽决、无级别宝珠等奖励。' },
        { id: 3, name: '赞助宝箱', price: 1000, image: require('../assets/logo.jpg'), description: '可随机获得银子、神兜兜、特殊兽决、无级别宝珠等奖励。' },
        { id: 4, name: '赞助宝箱', price: 20000, image: require('../assets/logo.jpg'), description: '可随机获得银子、神兜兜、特殊兽决、无级别宝珠等奖励。' },
      ];

      this.product = productList.find(product => product.id === Number(productId));
      this.calculateTotalPrice();
    },
    copyToClipboard() {
      // 获取输入框元素
      const input = this.$refs.orderUrlInput;
      
      // 选择文本
      input.select();
      input.setSelectionRange(0, 99999); // 对于移动设备

      // 执行复制命令
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          alert('已复制到剪贴板！');
        } else {
          alert('复制失败，请手动复制。');
        }
      } catch (err) {
        console.error('复制失败:', err);
      }
    },
  generateProductId() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0'); // 毫秒通常是3位数

  // 拼接成ID
  const productId = `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;

  return productId;
},
startPolling() {
      this.intervalId = setInterval(async () => {
        try {
          const response = await axios.get(`/getPay?newProductId=${this.newProductId}`);
          console.log(response.data);
          if (response.data && response.data.cdkey) {
          
            this.cdKey = response.data.cdkey;
            this.isCdKeyAvailable = true;
            clearInterval(this.intervalId);
          }
        } catch (error) {
          console.error('Error polling data:', error);
        }
      }, 5000);
    },
 
// 示例使用

    calculateTotalPrice() {
      if (this.product) {
        this.totalPrice = (this.product.price * this.quantity).toFixed(2);
      }
    },
    
    checkDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      this.isMobile = /android|iPad|iPhone|iPod/i.test(userAgent.toLowerCase());
    },
    closeModal() {
      this.isValidResponse = false;
      clearInterval(this.intervalId);
    },
    beforeDestroy() {
    // 在组件销毁之前清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
    placeOrder() {
      if (!this.email) {
       alert("请认真填写邮箱后下单")
      } else {
        this.emailError = '';
        console.log(`商品名称: ${this.product.name}`);
        console.log(`购买数量: ${this.quantity}`);
        console.log(`总价: ${this.totalPrice}`);
        console.log(`联系邮箱: ${this.email}`);
        // 执行下单逻辑
        this.newProductId = this.generateProductId();
       console.log(this.newProductId);
       this.orderParams.totalPrice = this.totalPrice;
       this.orderParams.email = this.email;
       this.orderParams.newProductId = this.newProductId;



      //  const orderData = Object.entries(this.orderParams)
      //   .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      //   .join('&');
      
 axios.post('/getSign', this.orderParams ,{
  // 请求体内容
})
.then(response => {
  console.log(response.data);
  if (
          response.data.code === 0 &&
          response.data.data &&
          response.data.data.order_url &&
          response.data.data.QRcode_url
        ) {
          this.orderUrl = response.data.data.order_url;
          this.qrCodeUrl = response.data.data.QRcode_url;
          this.isValidResponse = true;
          this.checkDeviceType();
          this.startPolling();
        } else {
          this.isValidResponse = false;
        }

})
.catch(error => {
  console.error(error);
  this.isValidResponse = false;
});

      // axios.post('http://127.0.0.1:8080/getSign', orderData, {
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //   },
       
      // })
      // .then(response => {
      //   console.log(response.data);
      //   // 在这里处理响应数据
      // })
      // .catch(error => {
      //   console.error('Error:', error);
      //   // 在这里处理错误
      // });

      }
    },
  },
};
</script>

<style>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-content a {
  display: block;
  margin-top: 10px;
  color: #007bff;
  text-decoration: none;
}

.modal-content button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-content button:hover {
  background-color: #0056b3;
}
.product-detail {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 100vh;
  box-sizing: border-box;
}

.product-card {
  max-width: 400px;
  width: 100%;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  background-color: #fff;
}

.product-image {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.product-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.product-description {
  margin-bottom: 20px;
  white-space: normal;
  overflow: visible;
  word-wrap: break-word;
}

.product-price {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.total-price {
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: bold;

}

.order-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.order-button:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .product-card {
    padding: 15px;
  }

  .product-title {
    font-size: 20px;
  }

  .product-price,
  .total-price {
    font-size: 16px;
  }
}
</style>